import { ReactElement, useMemo } from 'react'
import { fullDocumentationRootGuid } from '@constants'
import { orderBy } from 'lodash-es'
import { Box } from '@mui/material'
import DocumentFileRow from '@editor/components/DocumentFileRow'
import { EmptyState } from '@ui2/feedback'
import { useProjectFiles } from '@editorHooks'

interface Props {
  selectedDocument: string | null
  onSelectDocument: (document: string | null) => void
}

const FullStructuralDocumentsList = ({
  selectedDocument,
  onSelectDocument,
}: Props): ReactElement => {
  const { data } = useProjectFiles(fullDocumentationRootGuid)

  // Newest first, like the previous list
  const documents = useMemo(
    () =>
      orderBy(
        data.files,
        [file => (file.created ? new Date(file.created).getTime() : 0)],
        ['desc'],
      ),
    [data.files],
  )

  if (documents.length === 0) {
    return <EmptyState>Keine Dokumente gefunden</EmptyState>
  }

  return (
    <Box>
      {documents.map(file => (
        <DocumentFileRow
          key={file.guid}
          file={file}
          rootGuid={fullDocumentationRootGuid}
          selected={file.guid === selectedDocument}
          onClick={() => onSelectDocument(file.guid)}
          onDelete={() => {
            if (file.guid === selectedDocument) onSelectDocument(null)
          }}
        />
      ))}
    </Box>
  )
}

export default FullStructuralDocumentsList
